module.exports = __webpack_public_path__ + "img/yq-p.a422121e.png";